// @flow
import { schema } from 'normalizr';
import { routeStop } from './routeStops';
import { gateway } from './gateways';
import { student } from './students';


export const changeStopRequest = new schema.Entity('changeStopRequest', {
  from_stop: routeStop,
  to_stop: routeStop,
  to_gateway: gateway,
  from_gateway: gateway,
  student: student,
});
export const arrayOfChangeStopRequest = new schema.Array(changeStopRequest);



// WEBPACK FOOTER //
// ./src/scripts/api/schemas/changeStopRequest.js